// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header ion-toolbar {
  --background: var(--ion-color-primary);
  --ion-color-base: var(--ion-color-primary) !important;
}

ion-avatar {
  --border-radius: 0 !important;
}

.btn-remove-photo {
  position: absolute;
  left: 62%;
  bottom: -10%;
}

h2 {
  color: var(--ion-color-primary);
}

.image-ad {
  border-radius: 10px;
  box-shadow: 5px 10px 18px #d0cfcf;
}

ion-label {
  --color: #000;
}

lord-icon {
  width: 128px;
  height: 128px;
}

.card-type-ad {
  border-radius: 25px;
}

.item.sc-ion-label-md-h, .item .sc-ion-label-md-h, .item.sc-ion-label-ios-h, .item .sc-ion-label-ios-h {
  white-space: normal;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5ldy1hZC5wYWdlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0k7RUFDSSxzQ0FBQTtFQUNBLHFEQUFBO0FBQVI7O0FBR0E7RUFDSSw2QkFBQTtBQUFKOztBQUVBO0VBQ0ksa0JBQUE7RUFDQSxTQUFBO0VBQ0EsWUFBQTtBQUNKOztBQUNBO0VBQ0ksK0JBQUE7QUFFSjs7QUFBQTtFQUNJLG1CQUFBO0VBQ0EsaUNBQUE7QUFHSjs7QUFEQTtFQUNJLGFBQUE7QUFJSjs7QUFGQTtFQUNJLFlBQUE7RUFDQSxhQUFBO0FBS0o7O0FBSEE7RUFDSSxtQkFBQTtBQU1KOztBQUhBO0VBQ0ksbUJBQUE7QUFNSiIsImZpbGUiOiJuZXctYWQucGFnZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiaW9uLWhlYWRlcntcclxuICAgIGlvbi10b29sYmFyIHtcclxuICAgICAgICAtLWJhY2tncm91bmQ6IHZhcigtLWlvbi1jb2xvci1wcmltYXJ5KTtcclxuICAgICAgICAtLWlvbi1jb2xvci1iYXNlOiB2YXIoLS1pb24tY29sb3ItcHJpbWFyeSkgIWltcG9ydGFudDtcclxuICAgIH1cclxufVxyXG5pb24tYXZhdGFye1xyXG4gICAgLS1ib3JkZXItcmFkaXVzOiAwICFpbXBvcnRhbnQ7XHJcbn1cclxuLmJ0bi1yZW1vdmUtcGhvdG97XHJcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XHJcbiAgICBsZWZ0OiA2MiU7XHJcbiAgICBib3R0b206IC0xMCU7XHJcbn1cclxuaDJ7XHJcbiAgICBjb2xvcjogdmFyKC0taW9uLWNvbG9yLXByaW1hcnkpO1xyXG59XHJcbi5pbWFnZS1hZHtcclxuICAgIGJvcmRlci1yYWRpdXM6IDEwcHg7XHJcbiAgICBib3gtc2hhZG93OiA1cHggMTBweCAxOHB4ICNkMGNmY2Y7XHJcbn1cclxuaW9uLWxhYmVse1xyXG4gICAgLS1jb2xvcjogIzAwMDtcclxufVxyXG5sb3JkLWljb24ge1xyXG4gICAgd2lkdGg6IDEyOHB4O1xyXG4gICAgaGVpZ2h0OiAxMjhweDtcclxufVxyXG4uY2FyZC10eXBlLWFke1xyXG4gICAgYm9yZGVyLXJhZGl1czogMjVweDtcclxufVxyXG5cclxuLml0ZW0uc2MtaW9uLWxhYmVsLW1kLWgsIC5pdGVtIC5zYy1pb24tbGFiZWwtbWQtaCwgLml0ZW0uc2MtaW9uLWxhYmVsLWlvcy1oLCAuaXRlbSAuc2MtaW9uLWxhYmVsLWlvcy1oe1xyXG4gICAgd2hpdGUtc3BhY2U6IG5vcm1hbDtcclxufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/new-ad/new-ad.page.scss"],"names":[],"mappings":"AACI;EACI,sCAAA;EACA,qDAAA;AAAR;;AAGA;EACI,6BAAA;AAAJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,YAAA;AACJ;;AACA;EACI,+BAAA;AAEJ;;AAAA;EACI,mBAAA;EACA,iCAAA;AAGJ;;AADA;EACI,aAAA;AAIJ;;AAFA;EACI,YAAA;EACA,aAAA;AAKJ;;AAHA;EACI,mBAAA;AAMJ;;AAHA;EACI,mBAAA;AAMJ;AACA,wgDAAwgD","sourcesContent":["ion-header{\r\n    ion-toolbar {\r\n        --background: var(--ion-color-primary);\r\n        --ion-color-base: var(--ion-color-primary) !important;\r\n    }\r\n}\r\nion-avatar{\r\n    --border-radius: 0 !important;\r\n}\r\n.btn-remove-photo{\r\n    position: absolute;\r\n    left: 62%;\r\n    bottom: -10%;\r\n}\r\nh2{\r\n    color: var(--ion-color-primary);\r\n}\r\n.image-ad{\r\n    border-radius: 10px;\r\n    box-shadow: 5px 10px 18px #d0cfcf;\r\n}\r\nion-label{\r\n    --color: #000;\r\n}\r\nlord-icon {\r\n    width: 128px;\r\n    height: 128px;\r\n}\r\n.card-type-ad{\r\n    border-radius: 25px;\r\n}\r\n\r\n.item.sc-ion-label-md-h, .item .sc-ion-label-md-h, .item.sc-ion-label-ios-h, .item .sc-ion-label-ios-h{\r\n    white-space: normal;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
